import ExperimentContextLoader, {
  ExperimentContextHook,
  IExperimentContextLoaderProps
} from "../Components/ExperimentContextLoader";
import { convertSDK } from "../constants/ConvertSdk";
import useConvertDotCom from "../hooks/useConvertDotCom";
import useGetActiveExperimentsManualAuth from "../hooks/useGetActiveExperimentsManualAuth";
import useReportConnectionError from "../hooks/useReportConnectionError";

/** Bind the real convert sdk into the experience hook. */
const firstUseGetExperimentContextHook: ExperimentContextHook = props =>
  useConvertDotCom({ ...props, sdk: convertSDK });

/** A {@link ExperimentContextLoader} which supplies the experiment service connection hooks. */
const ObxExperimentContextLoader: React.FC<IExperimentContextLoaderProps> = props =>
  ExperimentContextLoader({
    ...props,
    useGetActiveExperiments: useGetActiveExperimentsManualAuth,
    useFirstUseGetExperimentContext: firstUseGetExperimentContextHook,
    useReportConnectionError: useReportConnectionError
  });

export default ObxExperimentContextLoader;
